import { makeStyles } from '@material-ui/core';
import { Grid, Typography } from '@material-ui/core';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import ColoredFormattedNumberForeign from 'components/ColoredFormattedNumberForeign';
import MyTable, { MyTableBody, MyTableCol, MyTableHeader, MyTableRow } from 'components/MyTable';
import Spin from 'components/Spin';
import { variables } from 'components/Theme';
import React, { useMemo } from 'react';
import { useObservable } from 'react-use-observable';
import financialService from 'v2/services/financial';

const useStyle = makeStyles(() => ({
  wrapper: {
    boxShadow: variables.shadows[1],
    borderRadius: '4px',
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  scroll: {
    overflowX: 'auto',
    width: '100%',
    padding: '0 1.5rem 1rem 1.5rem',
  },
  tableTitle: {
    backgroundColor: '#fff',
    padding: '1rem 1.5rem',
    borderRadius: '4px 4px 0 0',
    color: '#586375',
    fontSize: '0.875rem',
  },
  tableTitleText: {
    color: '#586375',
    fontSize: '1rem',
    fontWeight: 500,
  },
}));

const indexes = [
  { title: 'Conteúdo', ordering: false },
  { title: 'Valor', ordering: false, numeric: true },
];

const BlockedTable: React.FC = () => {
  const classes = useStyle({});
  const [data, error] = useObservable(() => financialService.listBlockedExtract(), []);

  const isLoading = data === null && error === undefined;

  const renderTableRow = useMemo(() => {
    if (isLoading) {
      return null;
    }

    if (!!data?.length) {
      return data.map((item, index) => (
        <MyTableRow hover={true} key={index}>
          <MyTableCol screenSizes={{ xs: 12, sm: 5 }} style={{ paddingTop: 13, paddingBottom: 13 }}>
            {item.description}
          </MyTableCol>
          <MyTableCol screenSizes={{ xs: 12, sm: 2 }} style={{ paddingTop: 13, paddingBottom: 13 }} numeric>
            <ColoredFormattedNumber value={item.value} format='BRL' />
            <ColoredFormattedNumberForeign value={item.origin_currency_value} separator=' / ' />
          </MyTableCol>
        </MyTableRow>
      ));
    }

    return (
      <MyTableRow>
        <MyTableCol screenSizes={{ xs: 12, sm: 12 }} colSpan={5}>
          Nenhum registro encontrado
        </MyTableCol>
      </MyTableRow>
    );
  }, [data, isLoading]);

  return (
    <div className={classes.wrapper}>
      <Grid container justify='space-between' className={classes.tableTitle}>
        <Grid item>
          <Typography className={classes.tableTitleText}>Bloqueados</Typography>
        </Grid>
      </Grid>

      <div className={classes.scroll}>
        {isLoading && (
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Spin />
          </div>
        )}

        <MyTable>
          <MyTableHeader index={indexes} />

          <MyTableBody>{renderTableRow}</MyTableBody>
        </MyTable>

        <div style={{ textAlign: 'right', padding: '0.5rem 0', fontSize: '14px' }}>
          Total bloqueado: <ColoredFormattedNumber format='BRL' value={!!data?.length ? data.reduce((a, b) => a + b.value, 0) : 0} />
        </div>

        <div style={{ textAlign: 'right', padding: '0.5rem 0', fontSize: '14px' }}>
          <ColoredFormattedNumberForeign
            value={!!data?.length ? data.reduce((a, b) => a + b.origin_currency_value, 0) : 0}
            separator='Total bloqueado: '
          />
        </div>
      </div>
    </div>
  );
};

export default BlockedTable;
